import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import './AboutNav.css';
import logo from '../../Assets/Images/logo.png';

const AboutNav = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className={`trillion-nav ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <img src={logo} alt="Trillions Logo" className="nav-logo-img" />
                          <span className="nav-logo-text">Trillion Stock Research</span>
        </Link>

        <button className="mobile-menu-button" onClick={toggleMobileMenu}>
          {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <ul className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
          <li>
            <Link to="/" onClick={closeMobileMenu} className={isActive('/') ? 'active' : ''}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/about" onClick={closeMobileMenu} className={isActive('/about') ? 'active' : ''}>
              About
            </Link>
          </li>
          <li>
            <Link to="/esign" onClick={closeMobileMenu} className={isActive('/esign') ? 'active' : ''}>
              T&C eSign
            </Link>
          </li>
          <li>
            <Link to="/pricing" onClick={closeMobileMenu} className={isActive('/pricing') ? 'active' : ''}>
              Pricing
            </Link>
          </li>
          <li>
            <Link to="/payments" onClick={closeMobileMenu} className={isActive('/payments') ? 'active' : ''}>
              Payments
            </Link>
          </li>
          <li>
            <Link to="/policy" onClick={closeMobileMenu} className={isActive('/policy') ? 'active' : ''}>
              Policy
            </Link>
          </li>
          <li>
            <Link to="/complaints" onClick={closeMobileMenu} className={isActive('/complaints') ? 'active' : ''}>
              Complaints
            </Link>
          </li>
          <li>
            <Link to="/contact" onClick={closeMobileMenu} className={isActive('/contact') ? 'active' : ''}>
              Contact
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default AboutNav; 